module.exports = __webpack_public_path__ + "Frame405-f8de421c.webp";